import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'lib-chip',
  imports: [MatIconModule, CommonModule, MatTooltipModule],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss'
})
export class ChipComponent {
  @Input() text: string = '';
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'warning' | 'muted' | 'none' | 'outline' | 'disabled' | 'teal' | 'lemon' | 'fuchsia' | 'dark' = 'primary';
  @Input() hexColor: string = '';
  @Input() disabled: boolean = false;
  @Input() icon: string = '';
  @Input() svgIcon: string = '';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() tooltip: string = '';
  @Input() textColor: 'primary' | 'secondary' | 'danger' | 'warning' | 'muted' | 'tertiary' | 'disabled' | '' = '';
}
